import { useDisclosure } from '@chakra-ui/react';
import { Button, Drawer } from '@time-line/components/common';
import { ProductReviewsInner } from 'components/reviews/ProductReviewsInner';
import { ProductReviewsStars } from 'components/reviews/ProductReviewsStars';
import { useReviewedProducts } from 'hooks/reviews/useReviewedProducts';
import { aggregateProductRatings } from 'utils/reviews/aggregateProductRatings';

import { MIN_NUM_OF_REVIEWS } from '../constants';

interface ProductReviewsDrawerProps {
  productSlugs: string[];
  productTitle: string;
}

export function ProductReviewsDrawer({
  productSlugs,
  productTitle,
}: ProductReviewsDrawerProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: reviewedProducts } = useReviewedProducts({
    slugsToFilter: productSlugs,
  });
  const { ratingCount } = aggregateProductRatings(reviewedProducts ?? []);

  if (ratingCount < MIN_NUM_OF_REVIEWS) return null;

  return (
    <>
      <Button
        variant="link"
        onClick={onOpen}
        sx={{
          svg: { width: '16px', height: '16px' },
        }}
      >
        <ProductReviewsStars productSlugs={productSlugs} />
      </Button>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        title="Reviews"
        subtitle={productTitle}
        ariaLabel="reviews"
        width="min(100%, 1200px)"
      >
        <ProductReviewsInner productSlugs={productSlugs} />
      </Drawer>
    </>
  );
}
